import { motion } from "framer-motion";
import { Check, EnvelopeSimple } from "@phosphor-icons/react";

export const AboutSection = () => (
  <section id="about" className="py-14 sm:py-20 px-4 bg-white border-y border-[#d4dff0] scroll-mt-28" aria-labelledby="about-title">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="flex justify-center lg:justify-start">
        <div className="relative inline-block">
          <img
            src="https://customer-assets.emergentagent.com/job_embrace-words-app/artifacts/vpmt5vpn_IMG_3402.jpeg"
            alt="Ann, creator of Embrace the Magic of Words"
            className="w-full max-w-sm rounded-3xl border border-[#d4dff0] object-cover h-[340px] sm:h-[400px]"
          />
          <span className="font-nunito font-bold text-xl text-[#7358b3] absolute -top-5 -right-3 rotate-6 bg-white px-4 py-2 border border-[#d4dff0] rounded-xl">
            Hi, I'm Ann!
          </span>
        </div>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <span className="font-nunito font-bold text-xs uppercase tracking-[0.2em] text-[#7358b3] inline-block">Our story</span>
        <h2 id="about-title" className="font-nunito font-extrabold tracking-tight text-3xl sm:text-4xl text-[#17284b] mt-1 mb-5">About Ann &amp; Embrace the Magic of Words</h2>
        <div className="space-y-4 font-nunito text-base text-[#3f4d66] leading-relaxed">
          <p>
            I started creating these resources when my own daughter had learning needs that traditional materials weren't
            meeting. Teaching her at home, I learned that vocabulary grows best in small, predictable steps — with lots of
            encouragement along the way.
          </p>
          <p>
            Every workbook combines vocabulary instruction with traceable text and supported practice, so children can
            build words, sentences, and confidence at their own pace. Kids Corner and Lumi grew from the same idea: learning
            should feel safe, joyful, and a little bit magical.
          </p>
        </div>
        <ul className="mt-6 space-y-2.5">
          {["Print & go — no prep required", "Answer keys with every resource", "Designed for SPED, ESL/ELL, OT & homeschool", "Made by a mom, for diverse learners"].map((t) => (
            <li key={t} className="flex items-center gap-3 font-nunito font-medium text-[#17284b]">
              <span className="w-6 h-6 bg-primary rounded-full flex items-center justify-center"><Check size={14} weight="bold" className="text-white" /></span>
              {t}
            </li>
          ))}
        </ul>
        <a href="/contact" className="inline-flex items-center gap-2 mt-6 font-nunito font-bold text-[#17284b] underline underline-offset-4 hover:text-[#178478]" data-testid="about-contact-link">
          <EnvelopeSimple size={18} weight="bold" /> Get in touch
        </a>
      </motion.div>
    </div>
  </section>
);
